import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "29",
  viewBox: "0 0 22 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  id: "Vector 35",
  d: "M19 13.4796L6.64053 3.57959L3 3.57959L3 25.5796L6.64052 25.5796L19 15.6796L19 13.4796Z",
  stroke: "rgb(230,95,0)",
  "stroke-width": "5.87047"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }